<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 10px;">
            <el-select v-model="SelStatus" placeholder="请选择状态" filterable>
                <el-option :key="0" :value="-1" :label="'全部状态'"></el-option>
                <el-option v-for="item in orderStatus"
                           :key="'Status'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelPayType" placeholder="请选择支付类型" filterable>
                <!--<el-option :key="0" :value="0" :label="'全部支付类型'"></el-option>-->
                <el-option v-for="item in payTypes"
                           :key="'Status'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelGoodsNames" placeholder="物品名称" filterable>
                <el-option :key="0" :value="0" :label="'全部物品'"></el-option>
                <el-option v-for="item in allGoodsNames"
                           :key="'GoodsName'+item.Id"
                           :label="item.Name"
                           :value="item.Id">
                    <span style="float: left">{{ item.Name }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelRefundStatus" placeholder="退款状态" filterable>
                <!--<el-option :key="0" :value="-1" :label="'全部状态'"></el-option>-->
                <el-option v-for="item in refundOrderStatus"
                           :key="'RefundStatus'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelCourierId" placeholder="请选择驾驶员" filterable>
                <el-option :key="0" :value="0" :label="'全部驾驶员'"></el-option>
                <el-option v-for="item2 in allCouriers"
                           :key="'Product'+item2.Id"
                           :label="item2.Name"
                           :value="item2.Id">
                    <span style="float: left">{{ item2.Name }}</span>
                </el-option>
            </el-select>

            <el-select v-model="IsSendInvoice" placeholder="是否开票" filterable>
                <el-option :key="0" value="-1" :label="'全部'"></el-option>
                <el-option :key="1" value="1" :label="'已开票'"></el-option>
                <el-option :key="2" value="0" :label="'未开票'"></el-option>
            </el-select>
            <el-date-picker type="date" placeholder="开始时间" v-model="StartTime" value-format="yyyy-MM-dd"></el-date-picker>
            <el-date-picker type="date" placeholder="结束时间" v-model="EndTime" value-format="yyyy-MM-dd"></el-date-picker>
            <el-input v-model="SelUserName" placeholder="会员Id" style="width:200px;margin-left:10px;"></el-input>
            <el-input v-model="searchVal" placeholder="请输入订单号" style="width:200px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
            <!--<el-button @click="ExportExcel" class="el-button el-button--primary el-button--medium" v-if="isExport" style="margin-left:10px;">导出Excel</el-button>-->
        </el-col>

        <!--列表-->
        <el-table :data="members"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table"
                  class="custom-tbl"
                  :height="tableHeight"
                  style="width: 99%;">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>
            <el-table-column prop="OrderNo" label="订单号码" width="190px" sortable>
            </el-table-column>
            <el-table-column prop="StatusName" label="订单状态" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="NickName" label="会员昵称" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="UserId" label="会员Id" width="120px" sortable>
            </el-table-column>
            <el-table-column prop="CreationTime"
                             label="下单时间"
                             :formatter="formatCreationTime"
                             width="180px"
                             sortable>
            </el-table-column>
            <el-table-column label="预约取件时间" prop="AppointmentTime" width="200px" sortable>
            </el-table-column>
            <el-table-column label="物品名称" prop="GoodsName" width="120px" sortable>
            </el-table-column>
            <el-table-column label="物品数量" prop="GoodsQuantity" width="100px" sortable>
            </el-table-column>
            <el-table-column label="驾驶员" prop="CourierName" width="100px" sortable>
            </el-table-column>
            <el-table-column label="订单总额" prop="TotalAmount" width="100px" sortable>
            </el-table-column>
            <el-table-column label="支付总额" prop="PayAmount" width="100px" sortable>
            </el-table-column>
            <el-table-column label="支付类型" prop="PayTypeName" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="PayTime"
                             label="支付时间"
                             :formatter="formatPayTime"
                             width="180px"
                             sortable>
            </el-table-column>
            <el-table-column prop="TradeNo" label="支付交易号" width="120px" sortable>
            </el-table-column>
            <el-table-column prop="UserCouponId" label="使用优惠券" width="120px" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.UserCouponId>0 ? 'danger' : 'success'"
                            disable-transitions>
                        {{ scope.row.UserCouponId>0 ? "是" : "否" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="UserCouponAmount" label="优惠券金额" width="120px" sortable>
            </el-table-column>


            <!--<el-table-column prop="Remark" label="备注" width="" sortable>
    </el-table-column>-->
            <el-table-column prop="AcceptTime"
                             label="接单时间"
                             :formatter="formatAcceptTime"
                             width="180px"
                             sortable>
            </el-table-column>
            <el-table-column prop="PickUpTime"
                             label="取货时间"
                             :formatter="formatPickUpTime"
                             width="180px"
                             sortable>
            </el-table-column>
            <el-table-column prop="DeliveryTime"
                             label="送达时间"
                             :formatter="formatDeliveryTime"
                             width="180px"
                             sortable>
            </el-table-column>
            <el-table-column prop="SenderName" label="发件人" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="SenderMobile" label="发件人电话" width="120px" sortable>
            </el-table-column>
            <el-table-column prop="SenderAddress" label="发件地址" width="220px" sortable>
            </el-table-column>
            <el-table-column prop="RecipientName" label="收件人" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="RecipientMobile" label="收件人电话" width="120px" sortable>
            </el-table-column>
            <el-table-column prop="RecipientAddress" label="发件地址" width="220px" sortable>
            </el-table-column>
            <el-table-column prop="Distance" label="距离（米）" width="120px" sortable>
            </el-table-column>
            <el-table-column prop="RefundTypeName" label="退款状态" width="100px" sortable>
            </el-table-column>
            <el-table-column prop="IsSendInvoice" label="是否开票" width="100px" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.IsSendInvoice == '1' ? 'danger' : 'success'"
                            disable-transitions>
                        {{ scope.row.IsSendInvoice == '1' ? "是" : "否" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="220">
                <template scope="scope">
                    <el-button type="danger" size="small" @click="handleModifyCourier(scope.$index, scope.row)" v-if="isModifyCourier && scope.row.Status==1">分配驾驶员</el-button>
                    <el-button type="danger" size="small" @click="handleModifyCourier(scope.$index, scope.row)" v-if="isModifyCourier && scope.row.Status==2">更改驾驶员</el-button>
                    <!--<el-button size="small" @click="handleEdit(scope.$index, scope.row)">详情</el-button>-->
                    <el-button type="danger" size="small" @click="handleCancelOrder(scope.$index, scope.row)" v-if="isCancelOrder && scope.row.Status>0 &&scope.row.Status<4">取消订单</el-button>
                </template>
            </el-table-column>
            <el-table-column label="详情" width="70" fixed="right">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="20"
                           :total="total"
                           style="float: right">
            </el-pagination>
        </el-col>


        <!--编辑界面-->
        <el-dialog title="详情"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm"
                     label-width="120px"
                     ref="editForm">


                <el-collapse v-model="activeNames">
                    <el-collapse-item title="订单信息" name="1">



                        <el-form-item label="订单号码" prop="OrderNo">
                            <el-input v-model="editForm.OrderNo" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="用户Id" prop="UserId">
                            <el-input v-model="editForm.UserId" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="用户昵称" prop="nickName">
                        <el-input v-model="editForm.UserInfo.nickName" auto-complete="off" :readonly="true"></el-input>
                    </el-form-item>-->
                        <!--<el-form-item label="用户登录名" prop="Username">
                        <el-input v-model="editForm.UserInfo.Username" auto-complete="off" :readonly="true"></el-input>
                    </el-form-item>-->
                        <el-form-item label="预约取件日期" prop="AppointmentDate">
                            <el-date-picker type="date" placeholder="预约取件日期" v-model="editForm.AppointmentDate" auto-complete="off" :readonly="true" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="预约取件时段" prop="TimePeriodId">
                            <el-select v-model="editForm.TimePeriodId" placeholder="请选择取货时段" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择取货时段'"></el-option>
                                <el-option v-for="item in allTimePeriods"
                                           :key="'TimePeriod'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="物品名称" prop="GoodsNameId">
                            <el-select v-model="editForm.GoodsNameId" placeholder="请选择物品名称" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择物品名称'"></el-option>
                                <el-option v-for="item in allGoodsNames"
                                           :key="'GoodsNames'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物品重量(KG)" prop="GoodsWeight">
                            <el-input-number v-model="editForm.GoodsWeight" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="物品体积（m3）" prop="GoodsVolume">
                            <el-input-number v-model="editForm.GoodsVolume" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="物品数量" prop="GoodsQuantity">
                            <el-input-number v-model="editForm.GoodsQuantity" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>

                        <el-form-item label="发件拍照">
                            <div class="list body ebody">
                                <div v-for="(e, index) in senderPicturesList" style="width:80px;float:left; ">
                                    <span>
                                        <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                                                  :src="`${e.Picture}`">
                                        </el-image>
                                    </span>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="总金额" prop="TotalAmount">
                            <el-input-number v-model="editForm.TotalAmount" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="支付类型" prop="PayType">
                            <el-input-number v-model="editForm.PayType" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="微信支付金额" prop="WeChatAmount">
                            <el-input-number v-model="editForm.WeChatAmount" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="余额支付金额" prop="RechargeAmount">
                            <el-input-number v-model="editForm.RechargeAmount" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="优惠卷支付金额" prop="UserCouponAmount">
                            <el-input-number v-model="editForm.UserCouponAmount" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="使用优惠券" prop="GoodsNameId">
                            <el-select v-model="editForm.GoodsNameId" placeholder="请选择优惠券" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择优惠券'"></el-option>
                                <el-option v-for="item in allUserCoupons"
                                           :key="'UserCoupon'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单状态" prop="Status">
                            <el-select v-model="editForm.Status" placeholder="请选择订单状态" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择订单状态'"></el-option>
                                <el-option v-for="item in orderStatus"
                                           :key="'Status'+item.StatusCode"
                                           :label="item.StatusName"
                                           :value="item.StatusCode">
                                    <span style="float: left">{{ item.StatusName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单备注" prop="Remark">
                            <el-input type="textarea" placeholder="订单备注" v-model="editForm.Remark" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="下单时间" prop="CreationTime">
                            <el-date-picker v-model="editForm.CreationTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="发件人地址" prop="SenderAddress">
                            <el-input v-model="editForm.SenderAddress" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="发件人地址" prop="SenderUserAddressId">
                            <el-select v-model="editForm.SenderUserAddressId" placeholder="请选择发件人地址" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择发件人地址'"></el-option>
                                <el-option v-for="item in allUserAddress"
                                           :key="'SenderUserAddress'+item.Id"
                                           :label="item.UserName+'-'+item.UserMobile+'-'+item.AddressDetail"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.UserName }}-{{ item.UserMobile }}-{{ item.AddressDetail }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收件人地址" prop="RecipientAddress">
                            <el-input v-model="editForm.RecipientAddress" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="收件人地址" prop="RecipientUserAddressId">
                            <el-select v-model="editForm.RecipientUserAddressId" placeholder="请选择收件人地址" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择收件人地址'"></el-option>
                                <el-option v-for="item in allUserAddress"
                                           :key="'RecipientAddress'+item.Id"
                                           :label="item.UserName+'-'+item.UserMobile+'-'+item.AddressDetail"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.UserName }}-{{ item.UserMobile }}-{{ item.AddressDetail }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="距离（米）" prop="Distance">
                            <el-input-number v-model="editForm.Distance" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="接单时间" prop="AcceptTime">
                            <el-date-picker v-model="editForm.AcceptTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="驾驶员" prop="CourierId">
                            <el-select v-model="editForm.CourierId" placeholder="请选择驾驶员" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择驾驶员'"></el-option>
                                <el-option v-for="item in allCouriers"
                                           :key="'Courier'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="取货时间" prop="PickUpTime">
                            <el-date-picker v-model="editForm.PickUpTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="取货备注" prop="PickUpNote">
                            <el-input v-model="editForm.PickUpNote" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="取货地址" prop="PickUpAddress">
                            <el-input v-model="editForm.PickUpAddress" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>


                        <el-form-item label="送达时间" prop="DeliveryTime">
                            <el-date-picker v-model="editForm.DeliveryTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="送达拍照">
                            <div class="list body ebody">
                                <div v-for="(e, index) in deliveryPicturesList" style="width:80px;float:left; ">
                                    <span>
                                        <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                                                  :src="`${e.Picture}`">
                                        </el-image>
                                    </span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="送达备注" prop="DeliveryNote">
                            <el-input type="textarea" placeholder="送达备注" v-model="editForm.DeliveryNote" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="送达地址" prop="DeliveryAddress">
                            <el-input type="textarea" placeholder="送达地址" v-model="editForm.DeliveryAddress" :readonly="true"></el-input>
                        </el-form-item>

                        <el-form-item label="支付时间" prop="PayTime">
                            <el-date-picker v-model="editForm.PayTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="交易号" prop="TradeNo">
                            <el-input v-model="editForm.TradeNo" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="退款单号" prop="OutRefundNo">
                            <el-input v-model="editForm.OutRefundNo" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>

                        <el-form-item label="退款状态" prop="RefundType">
                            <el-select v-model="editForm.RefundType" placeholder="请选择退款状态" filterable disabled>
                                <el-option v-for="item in refundOrderStatus"
                                           :key="'RefundStatus'+item.StatusCode"
                                           :label="item.StatusName"
                                           :value="item.StatusCode">
                                    <span style="float: left">{{ item.StatusName }}</span>
                                    <!--<span style="float: right; color: #8492a6; font-size: 13px">{{ item.StatusName }}</span>-->
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申请退款状态" prop="RefundType">
                            <el-select v-model="editForm.RefundType" placeholder="请选择申请退款状态" filterable disabled>
                                <el-option v-for="item in applyRefundStatus"
                                           :key="'RefundStatus'+item.StatusCode"
                                           :label="item.StatusName"
                                           :value="item.StatusCode">
                                    <span style="float: left">{{ item.StatusName }}</span>
                                    <!--<span style="float: right; color: #8492a6; font-size: 13px">{{ item.StatusName }}</span>-->
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="初始支付金额" prop="InitOrderAmount">
                            <el-input-number v-model="editForm.InitOrderAmount" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>

                        <el-form-item label="开过发票" prop="IsSendInvoice">
                            <el-radio-group v-model="editForm.IsSendInvoice" disabled>
                                <el-radio class="radio" :label="1">是</el-radio>
                                <el-radio class="radio" :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>

                    </el-collapse-item>
                    <el-collapse-item title="会员信息" name="2">
                        <el-form-item label="用户Id">
                            {{editForm.UserInfo.Id}}
                        </el-form-item>
                        <el-form-item label="用户姓名">
                            {{editForm.UserInfo.Name}}
                        </el-form-item>
                        <el-form-item label="用户昵称">
                            {{editForm.UserInfo.nickName}}
                        </el-form-item>
                        <el-form-item label="用户登录名" prop="Username">
                            {{editForm.UserInfo.Username}}
                        </el-form-item>
                        <el-form-item label="用户电话" prop="Phone">
                            {{editForm.UserInfo.Phone}}
                        </el-form-item>
                        <el-form-item label="余额" prop="RechargeBalance">
                            {{editForm.UserInfo.RechargeBalance}}
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item title="发件地址信息" name="3">
                        <el-form-item label="地址Id">
                            {{editForm.SenderUserAddress.Id}}
                        </el-form-item>
                        <el-form-item label="姓名" prop="Name">
                            {{editForm.SenderUserAddress.UserName}}
                        </el-form-item>
                        <el-form-item label="电话" prop="nickName">
                            {{editForm.SenderUserAddress.UserMobile}}
                        </el-form-item>
                        <el-form-item label="地址" prop="Address">
                            {{editForm.SenderUserAddress.Address}}
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item title="收件地址信息" name="4">
                        <el-form-item label="地址Id">
                            {{editForm.RecipientUserAddress.Id}}
                        </el-form-item>
                        <el-form-item label="姓名">
                            {{editForm.RecipientUserAddress.UserName}}
                        </el-form-item>
                        <el-form-item label="电话">
                            {{editForm.RecipientUserAddress.UserMobile}}
                        </el-form-item>
                        <el-form-item label="地址">
                            {{editForm.RecipientUserAddress.Address}}
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item title="优惠券信息" name="5" v-if="editForm.UserCoupon!=null">
                        <el-form-item label="优惠券Id" prop="Id">
                            {{editForm.UserCoupon.Id}}
                        </el-form-item>
                        <el-form-item label="名称" prop="Name">
                            {{editForm.UserCoupon.Name}}
                        </el-form-item>
                        <el-form-item label="满金额" prop="SpendAmount">
                            {{editForm.UserCoupon.SpendAmount}}
                        </el-form-item>
                        <el-form-item label="减金额" prop="GetOffAmount">
                            {{editForm.UserCoupon.GetOffAmount}}
                        </el-form-item>
                        <el-form-item label="说明" prop="Instructions">
                            {{editForm.UserCoupon.Instructions}}
                        </el-form-item>
                        <el-form-item label="有效期开始" prop="ValidityStartTime">
                            {{editForm.UserCoupon.ValidityStartTime}}
                        </el-form-item>
                        <el-form-item label="有效期截止" prop="ValidityEndTime">
                            {{editForm.UserCoupon.ValidityEndTime}}
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item title="驾驶员信息" name="6" v-if="editForm.CourierInfo!=null">
                        <el-form-item label="驾驶员Id" prop="Id">
                            {{editForm.CourierInfo.Id}}
                        </el-form-item>
                        <el-form-item label="姓名" prop="Name">
                            {{editForm.CourierInfo.Name}}
                        </el-form-item>
                        <el-form-item label="登录账号" prop="Username">
                            {{editForm.CourierInfo.Username}}
                        </el-form-item>
                        <el-form-item label="电话" prop="Phone">
                            {{editForm.CourierInfo.Phone}}
                        </el-form-item>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <!--<el-button type="primary"
                   @click.native="editSubmit"
                   :loading="editLoading">提交</el-button>-->
            </div>
        </el-dialog>





        <!--编辑界面-->
        <el-dialog title="分配驾驶员"
                   :visible.sync="editCourierFormVisible"
                   v-model="editCourierFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editCourierForm"
                     label-width="120px"
                     ref="editCourierForm">


                        <el-form-item label="订单号码" prop="OrderNo">
                            <el-input v-model="editCourierForm.OrderNo" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="用户Id" prop="UserId">
                            <el-input v-model="editCourierForm.UserId" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="预约取件日期" prop="AppointmentDate">
                            <el-date-picker type="date" placeholder="预约取件日期" v-model="editCourierForm.AppointmentDate" auto-complete="off" :readonly="true" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="预约取件时段" prop="TimePeriodId">
                            <el-select v-model="editCourierForm.TimePeriodId" placeholder="请选择取货时段" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择取货时段'"></el-option>
                                <el-option v-for="item in allTimePeriods"
                                           :key="'TimePeriod'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="物品名称" prop="GoodsNameId">
                            <el-select v-model="editCourierForm.GoodsNameId" placeholder="请选择物品名称" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择物品名称'"></el-option>
                                <el-option v-for="item in allGoodsNames"
                                           :key="'GoodsNames'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物品重量(KG)" prop="GoodsWeight">
                            <el-input-number v-model="editCourierForm.GoodsWeight" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="物品体积（m3）" prop="GoodsVolume">
                            <el-input-number v-model="editCourierForm.GoodsVolume" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>
                        <el-form-item label="物品数量" prop="GoodsQuantity">
                            <el-input-number v-model="editCourierForm.GoodsQuantity" :min="0" :readonly="true" disabled></el-input-number>
                        </el-form-item>

                        <el-form-item label="发件拍照">
                            <div class="list body ebody">
                                <div v-for="(e, index) in senderPicturesList" style="width:80px;float:left; ">
                                    <span>
                                        <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                                                  :src="`${e.Picture}`">
                                        </el-image>
                                    </span>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="订单状态" prop="Status">
                            <el-select v-model="editCourierForm.Status" placeholder="请选择订单状态" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择订单状态'"></el-option>
                                <el-option v-for="item in orderStatus"
                                           :key="'Status'+item.StatusCode"
                                           :label="item.StatusName"
                                           :value="item.StatusCode">
                                    <span style="float: left">{{ item.StatusName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单备注" prop="Remark">
                            <el-input type="textarea" placeholder="订单备注" v-model="editCourierForm.Remark" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="下单时间" prop="CreationTime">
                            <el-date-picker v-model="editCourierForm.CreationTime"
                                            type="datetime"
                                            :readonly="true"
                                            value-format="yyyy-MM-dd hh:ss"
                                            format="yyyy-MM-dd hh:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="发件人地址" prop="SenderAddress">
                            <el-input v-model="editCourierForm.SenderAddress" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="发件人地址" prop="SenderUserAddressId">
                            <el-select v-model="editCourierForm.SenderUserAddressId" placeholder="请选择发件人地址" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择发件人地址'"></el-option>
                                <el-option v-for="item in allUserAddress"
                                           :key="'SenderUserAddress'+item.Id"
                                           :label="item.UserName+'-'+item.UserMobile+'-'+item.AddressDetail"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.UserName }}-{{ item.UserMobile }}-{{ item.AddressDetail }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收件人地址" prop="RecipientAddress">
                            <el-input v-model="editCourierForm.RecipientAddress" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="收件人地址" prop="RecipientUserAddressId">
                            <el-select v-model="editCourierForm.RecipientUserAddressId" placeholder="请选择收件人地址" filterable disabled>
                                <el-option :key="0" :value="0" :label="'请选择收件人地址'"></el-option>
                                <el-option v-for="item in allUserAddress"
                                           :key="'RecipientAddress'+item.Id"
                                           :label="item.UserName+'-'+item.UserMobile+'-'+item.AddressDetail"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.UserName }}-{{ item.UserMobile }}-{{ item.AddressDetail }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="驾驶员" prop="CourierId">
                            <el-select v-model="editCourierForm.CourierId" placeholder="请选择驾驶员" filterable>
                                <el-option :key="0" :value="0" :label="'请选择驾驶员'"></el-option>
                                <el-option v-for="item in allCouriers"
                                           :key="'Courier'+item.Id"
                                           :label="item.Name"
                                           :value="item.Id">
                                    <span style="float: left">{{ item.Name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editCourierFormVisible = false">取消</el-button>
                <el-button type="primary"
                   @click.native="editCourierSubmit"
                   :loading="editCourierLoading">提交</el-button>
            </div>
        </el-dialog>


    </section>
</template>

<script>
    import util from "../../../util/date";
    import {
        getPageOrders,
        removeOrders,
        getAllCourier,
        getAllTimePeriod,
        getAllGoodsName,
        getAllUserAddress,
        getAllUserCoupon,
        getCancelOrder,
        setOrderCourier
        //UpdateOrderDelivery,
        /* exportOrders*/
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /*import Toolbar from "../../components/Toolbar";*/
    //import global from '../../components/Global'//引用全局模块
    //import moment from 'moment'

    export default {
        /* components: { Toolbar },*/
        data() {
            return {
                filters: {
                    name: "",
                },
                tableHeight: 600,
                activeNames: ['1'],
                searchVal: "",
                members: [],
                total: 0,
                buttonList: [],
                currentRow: null,
                page: 1,
                listLoading: false,
                StartTime: "",
                EndTime: "",
                orderStatus: [{ StatusName: '未付款', StatusCode: 0 }, { StatusName: '已付款', StatusCode: 1 }, { StatusName: '已接单', StatusCode: 2 }, { StatusName: '已取货', StatusCode: 3 }, { StatusName: '已完成', StatusCode: 4 }, { StatusName: '已取消', StatusCode: 10 }],
                //refundOrderStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未退款', StatusCode: 0 }, { StatusName: '全额退款', StatusCode: 1 }, { StatusName: '部分退款', StatusCode: 2 }],
                refundOrderStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未退款', StatusCode: 0 }, { StatusName: '已退款', StatusCode: 1 }],
                applyRefundStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未申请', StatusCode: 0 }, { StatusName: '待审核', StatusCode: 1 }, { StatusName: '审核通过', StatusCode: 2 }, { StatusName: '审核不通过', StatusCode: 3 }],
                payTypes: [{ StatusName: '全部', StatusCode: 0 }, { StatusName: '余额支付', StatusCode: 1 }, { StatusName: '微信支付', StatusCode: 2 }],
                SelPayType: 0,
                SelStatus: -1,
                SelRefundStatus: -1,
                SelCourierId: 0,
                SelGoodsNames: 0,

                allTimePeriods: [],//所有预约时段
                allUserAddress: [],//用户的所有地址
                deliveryPicturesList: [],//送达拍照
                senderPicturesList: [],//发件拍照
                allGoodsNames: [],//物品名称
                allUserCoupons: [],//用户优惠券

                //SelStoreId: 0,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                SearchType: 0,
                isEdit: false,
                isDelete: false,
                isExport: false,
                isCancelOrder: false,
                isModifyCourier:false,

                allCouriers: [],

                IsSendInvoice: "-1",
                SelUserName: "",

                //编辑界面数据
                editForm: {
                    Id: 0,
                    OrderNo: "",
                    UserId: 0,
                    AppointmentDate: '',
                    TimePeriodId: 0,
                    CourierId: 0,
                    PayAmount: 0,
                    TotalAmount: 0,
                    PayType: 0,
                    WeChatAmount: 0,
                    RechargeAmount: 0,
                    UserCouponAmount: 0,
                    Status: -1,
                    Remark: '',
                    CreationTime: '',
                    CreatorId: 0,
                    IsDeleted: false,
                    SenderAddress: '',
                    SenderName: '',
                    SenderMobile: '',
                    SenderCompany: '',
                    SenderNote: '',
                    SenderLatitude: 0,
                    SenderLongitude: 0,
                    RecipientAddress: '',
                    RecipientName: '',
                    RecipientMobile: '',
                    RecipientCompany: '',
                    RecipientLongitude: 0,
                    RecipientLatitude: 0,

                    Distance: 0,
                    AcceptTime: '',
                    DeliveryTime: '',
                    DeliveryPictures: '',
                    DeliveryNote: '',
                    SenderPictures: '',
                    GoodsName: '',
                    GoodsWeight: 0,
                    GoodsVolume: 0,
                    GoodsQuantity: 1,
                    IsSendInvoice: false,
                    RecipientUserAddressId: 0,
                    SenderUserAddressId: 1,
                    GoodsNameId: 0,
                    UserCouponId: 0,
                    PayTime: '',
                    TradeNo: "",
                    OutRefundNo: "",
                    ApplyRefundStatus: 0,
                    RefundType: 0,
                    InitOrderAmount: 0,
                    PickUpTime: '',
                    PickUpPictures: '',
                    PickUpNote: '',
                    PickUpLongitude: 0,
                    PickUpLatitude: 0,
                    PickUpAddress: '',
                    DeliveryAddress: '',
                    DeliveryLongitude: 0,
                    DeliveryLatitude: 0,
                    UserInfo: {
                        Address: '',
                        Age: 0,
                        Birth: '',
                        CreationTime: '',
                        Email: '',
                        Gender: '',
                        HeadImageUrl: '',
                        Id: 0,
                        IsDeleted: false,
                        Name: '',
                        OpenId: '',
                        Phone: '',
                        RechargeBalance: 0,
                        Remark: '',
                        Status: 0,
                        Telephone: '',
                        Username: '',
                        nickName: ''
                    },
                    TimePeriodInfo: {
                        Id: 0,
                        Name: '',
                        StartTimeHour: 0,
                        StartTimeMinute: 0,
                        EndTimeHour: 0,
                        EndTimeMinute: 0,
                        Status: 0,
                        Remark: '',
                        Introduction: '',
                        OrderNum: 0,
                        OwnerUid: '',
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false,
                        StartTime: '',
                        EndTime: ''
                    },
                    CourierInfo: {
                        Id: 0,
                        Username: '',
                        Name: '',
                        Phone: '',
                        Gender: 1,
                        HeadImageUrl: '',
                        Position: '',
                        Birth: '',
                        Age: 0,
                        Status: 0,
                        Remark: '',
                        Telephone: '',
                        Address: '',
                        Email: '',
                        LastLoginTime: '',
                        CreationTime: '',
                        LastModificationTime: '',
                        IsDeleted: false,
                        GPSTime: '',
                        Longitude: 0,
                        Latitude: 0,
                        AddressProvince: '',
                        AddressCity: '',
                        AddressCounty: '',
                        AddressStreet: '',
                        AddressDetail: ''
                    },
                    AppointmentTime: '',
                    RecipientUserAddress: {
                        Id: 0,
                        UserId: 0,
                        AddressProvince: 0,
                        AddressCity: 0,
                        AddressCounty: 0,
                        AddressStreet: 0,
                        AddressDetail: '',
                        UserName: '',
                        UserMobile: 0,
                        Company: '',
                        IsDefault: false,
                        Status: 0,
                        Remark: '',
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false,
                        AddressProvinceName: '',
                        AddressCityName: '',
                        AddressCountyName: '',
                        AddressStreetName: '',
                        SelectionAddress: '',
                        Longitude: 0,
                        Latitude: 0,
                        AddressType: 0,
                        Address: '',
                        Name: ''
                    },
                    PayTypeName: '',
                    StatusName: '',
                    SenderUserAddress: {
                        Id: 0,
                        UserId: 0,
                        AddressProvince: 0,
                        AddressCity: 0,
                        AddressCounty: 0,
                        AddressStreet: 0,
                        AddressDetail: '',
                        UserName: '',
                        UserMobile: 0,
                        Company: '',
                        IsDefault: false,
                        Status: 0,
                        Remark: '',
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false,
                        AddressProvinceName: '',
                        AddressCityName: '',
                        AddressCountyName: '',
                        AddressStreetName: '',
                        SelectionAddress: '',
                        Longitude: 0,
                        Latitude: 0,
                        AddressType: 0,
                        Address: '',
                        Name: ''
                    },
                    GoodsNameInfo: {
                        Id: 0,
                        Name: '',
                        Status: 0,
                        Remark: '',
                        OrderNumber: 0,
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false
                    },
                    UserCoupon: {
                        UserId: 0,
                        CouponId: 0,
                        CreationTime: '',
                        Status: 1,
                        OrderId: 0,
                        UseAmount: 0,
                        UseNote: '',
                        ValidityStartTime: '',
                        ValidityEndTime: '',
                        IsDeleted: false,
                        DeleterId: 0,
                        DeletionTime: '',
                        UseTime: '',
                        Name: '',
                        SpendAmount: 0,
                        GetOffAmount: 0,
                        Instructions: '',
                        UserName: '',
                        NickName: '',
                        Id: 0
                    },
                    RefundTypeName: '',
                    ApplyRefundStatusName: '',
                },


                editCourierFormVisible: false, //编辑界面是否显示
                editCourierLoading: false,
                //编辑界面数据
                editCourierForm: {
                    Id: 0,
                    OrderNo: "",
                    UserId: 0,
                    AppointmentDate: '',
                    TimePeriodId: 0,
                    CourierId: 0,
                    PayAmount: 0,
                    TotalAmount: 0,
                    PayType: 0,
                    WeChatAmount: 0,
                    RechargeAmount: 0,
                    UserCouponAmount: 0,
                    Status: -1,
                    Remark: '',
                    CreationTime: '',
                    CreatorId: 0,
                    IsDeleted: false,
                    SenderAddress: '',
                    SenderName: '',
                    SenderMobile: '',
                    SenderCompany: '',
                    SenderNote: '',
                    SenderLatitude: 0,
                    SenderLongitude: 0,
                    RecipientAddress: '',
                    RecipientName: '',
                    RecipientMobile: '',
                    RecipientCompany: '',
                    RecipientLongitude: 0,
                    RecipientLatitude: 0,

                    Distance: 0,
                    AcceptTime: '',
                    DeliveryTime: '',
                    DeliveryPictures: '',
                    DeliveryNote: '',
                    SenderPictures: '',
                    GoodsName: '',
                    GoodsWeight: 0,
                    GoodsVolume: 0,
                    GoodsQuantity: 1,
                    IsSendInvoice: false,
                    RecipientUserAddressId: 0,
                    SenderUserAddressId: 1,
                    GoodsNameId: 0,
                    UserCouponId: 0,
                    PayTime: '',
                    TradeNo: "",
                    OutRefundNo: "",
                    ApplyRefundStatus: 0,
                    RefundType: 0,
                    InitOrderAmount: 0,
                    PickUpTime: '',
                    PickUpPictures: '',
                    PickUpNote: '',
                    PickUpLongitude: 0,
                    PickUpLatitude: 0,
                    PickUpAddress: '',
                    DeliveryAddress: '',
                    DeliveryLongitude: 0,
                    DeliveryLatitude: 0,
                    UserInfo: {
                        Address: '',
                        Age: 0,
                        Birth: '',
                        CreationTime: '',
                        Email: '',
                        Gender: '',
                        HeadImageUrl: '',
                        Id: 0,
                        IsDeleted: false,
                        Name: '',
                        OpenId: '',
                        Phone: '',
                        RechargeBalance: 0,
                        Remark: '',
                        Status: 0,
                        Telephone: '',
                        Username: '',
                        nickName: ''
                    },
                    TimePeriodInfo: {
                        Id: 0,
                        Name: '',
                        StartTimeHour: 0,
                        StartTimeMinute: 0,
                        EndTimeHour: 0,
                        EndTimeMinute: 0,
                        Status: 0,
                        Remark: '',
                        Introduction: '',
                        OrderNum: 0,
                        OwnerUid: '',
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false,
                        StartTime: '',
                        EndTime: ''
                    },
                    CourierInfo: {
                        Id: 0,
                        Username: '',
                        Name: '',
                        Phone: '',
                        Gender: 1,
                        HeadImageUrl: '',
                        Position: '',
                        Birth: '',
                        Age: 0,
                        Status: 0,
                        Remark: '',
                        Telephone: '',
                        Address: '',
                        Email: '',
                        LastLoginTime: '',
                        CreationTime: '',
                        LastModificationTime: '',
                        IsDeleted: false,
                        GPSTime: '',
                        Longitude: 0,
                        Latitude: 0,
                        AddressProvince: '',
                        AddressCity: '',
                        AddressCounty: '',
                        AddressStreet: '',
                        AddressDetail: ''
                    },
                    AppointmentTime: '',
                    RecipientUserAddress: {
                        Id: 0,
                        UserId: 0,
                        AddressProvince: 0,
                        AddressCity: 0,
                        AddressCounty: 0,
                        AddressStreet: 0,
                        AddressDetail: '',
                        UserName: '',
                        UserMobile: 0,
                        Company: '',
                        IsDefault: false,
                        Status: 0,
                        Remark: '',
                        CreationTime: '',
                        CreatorId: 0,
                        LastModificationTime: '',
                        LastModifierId: 0,
                        IsDeleted: false,
                        AddressProvinceName: '',
                        AddressCityName: '',
                        AddressCountyName: '',
                        AddressStreetName: '',
                        SelectionAddress: '',
                        Longitude: 0,
                        Latitude: 0,
                        AddressType: 0,
                        Address: '',
                        Name: ''
                    },
                    PayTypeName: '',
                    StatusName: ''
                },

            };
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 20;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            onEditorReady(editor) { },
            dialogCheck(selection, row) {
                this.currentRow = null;
                this.$refs.table.clearSelection();
                if (selection.length === 0) {
                    return;
                }
                if (row) {
                    this.selectCurrentRow(row);
                }
            },
            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            ////性别显示转换
            //formatSex: function (row, column) {
            //  return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
            //},
            formatCreationTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatAcceptTime: function (row, column) {
                return !row.AcceptTime || row.AcceptTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.AcceptTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatPickUpTime: function (row, column) {
                return !row.PickUpTime || row.PickUpTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.PickUpTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatDeliveryTime: function (row, column) {
                return !row.DeliveryTime || row.DeliveryTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.DeliveryTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatPayTime: function (row, column) {
                return !row.PayTime || row.PayTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.PayTime), "yyyy-MM-dd hh:mm:ss");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },

            //ChangeStatus(value) {
            //    this.SearchType = value;
            //    if (value == 9) {
            //        this.ShowDelivery = true;
            //    } else {
            //        this.ShowDelivery = false;
            //    }
            //},

            //获取所有商品
            handleAllCouriers() {
                let para = {
                };
                this.listLoading = true;

                //NProgress.start();
                getAllCourier(para).then((res) => {
                    this.allCouriers = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //获取用户列表
            handleQuery() {
                var userId = "0";
                if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
                    userId = "0";
                } else {
                    userId = this.SelUserName;
                }
                let para = {
                    page: this.page,
                    key: this.searchVal,//this.filters.name,
                    CourierId: this.SelCourierId,
                    Status: this.SelStatus,
                    PayType: this.SelPayType,
                    RefundType: this.SelRefundStatus,
                    IsSendInvoice: this.IsSendInvoice,
                    StartTime: this.StartTime,
                    EndTime: this.EndTime,
                    UserId: userId,
                    GoodsNameId: this.SelGoodsNames
                };
                this.listLoading = true;

                //NProgress.start();
                getPageOrders(para).then((res) => {
                    this.total = res.data.response.dataCount;
                    //this.members = res.data.response.data;
                    var orderList = res.data.response.data;
                    //if (orderList != null && orderList.length > 0) {
                    //    for (var i = 0; i < orderList.length; i++) {
                    //        console.log(11);
                    //        console.log(orderList[i]);
                    //        console.log(orderList[i].UserInfo);
                    //        console.log(22);
                    //    }
                    //}
                    //if (orderList != null && orderList.length > 0) {
                    //    for (var i = 0; i < orderList.length; i++) {
                    //        if (orderList[i].Status >= 2) {
                    //            var labels = orderList[i].ClothesLabels;
                    //            if (labels != null && labels.length > 0) {
                    //                for (var j = 0; j < labels.length; j++) {
                    //                    var pictures = labels[j].ClothesPictures;
                    //                    if (pictures != null && pictures.length > 0) {
                    //                        for (var k = 0; k < pictures.length; k++) {
                    //                            var pInfo = pictures[k].Picture;
                    //                            if (pInfo != null && pInfo != "") {
                    //                                pictures[k].Picture = global.PictureDemain + pictures[k].Picture;
                    //                            }
                    //                        }
                    //                    }
                    //                }
                    //            }
                    //        }
                    //        var oproducts = orderList[i].OrderProductList;
                    //        console.log(oproducts);
                    //        if (oproducts != null && oproducts.length > 0) {
                    //            for (var j = 0; j < oproducts.length; j++) {
                    //                var coverImage = oproducts[j].ProductInfo.CoverImage;
                    //                if (coverImage != null && coverImage != "" && !coverImage.startsWith("http")) {
                    //                    oproducts[j].ProductInfo.CoverImage = global.PictureDemain + coverImage;
                    //                    console.log(global.PictureDemain + coverImage);
                    //                }
                    //                console.log(coverImage);
                    //            }
                    //        }
                    //    }
                    //}
                    this.members = orderList;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            handleCancelOrder(index, row) {
                this.currentRow = row;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });
                    return;
                }
                this.$confirm("确认要取消订单吗？", "提示", {}).then(() => {
                    this.editLoading = true;
                    var para = {
                        Id: row.Id
                    };
                    getCancelOrder(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.editLoading = false;
                            return;
                        }
                        if (res.data.success) {


                            this.editLoading = false;
                            this.$message({
                                message: res.data.msg,
                                type: "success",
                            });
                            //this.$refs["editForm"].resetFields();
                            //this.options = [];
                            //this.editFormVisible = false;
                            this.handleQuery();
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                            this.editLoading = false;
                        }
                    });

                });
            },
            //显示编辑界面
            handleEdit(index, row) {
                //let row = this.currentRow;
                this.currentRow = row;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.editForm.IsSendInvoice = 0;
                console.log("row.IsSendInvoice=" + row.IsSendInvoice);
                if (row.IsSendInvoice == true) {
                    this.editForm.IsSendInvoice = 1;
                }
                console.log("this.editForm.IsSendInvoice=" + this.editForm.IsSendInvoice);
                this.allUserAddress = [];
                this.getAllUserAddressList(row.UserId);
                this.allUserCoupons = [];
                this.getAllUserCouponList(row.UserId);
                this.deliveryPicturesList = [];
                if (row.DeliveryPictures != null && row.DeliveryPictures != "") {
                    var RVoucher = String(row.DeliveryPictures);
                    var vouchers = RVoucher.split(",");
                    //console.log('bbb');
                    for (var i = 0; i < vouchers.length; i++) {
                        var inNo = vouchers[i].toString();
                        if (inNo != null && inNo != "") {
                            this.deliveryPicturesList.push({
                                Picture: inNo
                            });
                        }
                    }
                }
                this.senderPicturesList = [];
                if (row.SenderPictures != null && row.SenderPictures != "") {
                    var RVoucher = String(row.SenderPictures);
                    var vouchers = RVoucher.split(",");
                    //console.log('bbb');
                    for (var i = 0; i < vouchers.length; i++) {
                        var inNo = vouchers[i].toString();
                        if (inNo != null && inNo != "") {
                            this.senderPicturesList.push({
                                Picture: inNo
                            });
                        }
                    }
                }
                //this.editForm.UserInfo = row.UserInfo;
                //console.log(this.editForm.UserInfo);
                ////this.SearchType = row.Status;

                ////console.log(row.Status);
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);

                            //para.birth =
                            //  !para.birth || para.birth == ""
                            //    ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                            //    : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                            /*para.DepartmentId = para.Dids.pop();*/
                            //para.CoverImage = this.EditCoverImage;
                            //var Status = para.Status;
                            //if (Status == 9) {
                            //    //已发货
                            //    var ExpressCompany = para.ExpressCompany;
                            //    var ExpressNnmber = para.ExpressNnmber;
                            //    var Consignee = para.Consignee;

                            //    var Telephone = para.Telephone;
                            //    var Address = para.Address;

                            //    if (ExpressCompany == null || ExpressCompany == "") {
                            //        this.$message({
                            //            message: "请输入快递公司！",
                            //            type: "error"
                            //        });
                            //        this.editLoading = false;
                            //        return;
                            //    } if (ExpressNnmber == null || ExpressNnmber == "") {
                            //        this.$message({
                            //            message: "请输入快递单号！",
                            //            type: "error"
                            //        });
                            //        this.editLoading = false;
                            //        return;
                            //    } if (Consignee == null || Consignee == "") {
                            //        this.$message({
                            //            message: "请输入收件人！",
                            //            type: "error"
                            //        });
                            //        this.editLoading = false;
                            //        return;
                            //    }
                            //    if (Telephone == null || Telephone == "") {
                            //        this.$message({
                            //            message: "请输入收件人电话！",
                            //            type: "error"
                            //        });
                            //        this.editLoading = false;
                            //        return;
                            //    } if (Address == null || Address == "") {
                            //        this.$message({
                            //            message: "请输入收件人地址！",
                            //            type: "error"
                            //        });
                            //        this.editLoading = false;
                            //        return;
                            //    }
                            //}

                            //UpdateProductOrderDelivery(para).then((res) => {
                            //    if (util.isEmt.format(res)) {
                            //        this.editLoading = false;
                            //        return;
                            //    }
                            //    if (res.data.success) {
                            //        this.editLoading = false;
                            //        this.$message({
                            //            message: res.data.msg,
                            //            type: "success",
                            //        });
                            //        this.$refs["editForm"].resetFields();
                            //        this.editFormVisible = false;
                            //        this.handleQuery();
                            //    } else {
                            //        this.$message({
                            //            message: res.data.msg,
                            //            type: "error",
                            //        });
                            //        this.editLoading = false;
                            //    }
                            //});
                        });
                    }
                });
            },
            handleModifyCourier(index, row) {
                //let row = this.currentRow;
                this.currentRow = row;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.editCourierFormVisible = true;
                this.editCourierForm = Object.assign({}, row);

                this.allUserAddress = [];
                this.getAllUserAddressList(row.UserId);
                this.allUserCoupons = [];
                this.getAllUserCouponList(row.UserId);
                this.senderPicturesList = [];
                if (row.SenderPictures != null && row.SenderPictures != "") {
                    var RVoucher = String(row.SenderPictures);
                    var vouchers = RVoucher.split(",");
                    //console.log('bbb');
                    for (var i = 0; i < vouchers.length; i++) {
                        var inNo = vouchers[i].toString();
                        if (inNo != null && inNo != "") {
                            this.senderPicturesList.push({
                                Picture: inNo
                            });
                        }
                    }
                }
            },
            //编辑
            editCourierSubmit: function () {
                this.$refs.editCourierForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editCourierLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editCourierForm);

                                para.OrderId = para.Id;
                                var CourierId = para.CourierId;

                            if (para.Id == null || para.Id <=0) {
                                    this.$message({
                                        message: "请选择订单！",
                                        type: "error"
                                    });
                                this.editCourierLoading = false;
                                    return;
                            } if (para.CourierId == null || para.CourierId <= 0) {
                                this.$message({
                                    message: "请选择驾驶员！",
                                    type: "error"
                                });
                                this.editCourierLoading = false;
                                return;
                            }
                            let para2 = {
                                OrderId: para.Id,
                                CourierId: para.CourierId
                            };

                            setOrderCourier(para2).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.editCourierLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editCourierLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["editCourierForm"].resetFields();
                                    this.editCourierFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    this.editCourierLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            ////导出excel
            //ExportExcel() {
            //    //let _this = this;
            //    var userId = "0";
            //    if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
            //        userId = "0";
            //    } else {
            //        userId = this.SelUserName;
            //    }
            //    let para = {
            //        page: this.page,
            //        key: this.searchVal,//this.filters.name,
            //        StoreId: this.SelStoreId,
            //        CourierId: this.SelCourierId,
            //        Status: this.SelStatus,
            //        RefundType: this.SelRefundStatus,
            //        IsSendInvoice: this.IsSendInvoice,
            //        UserId: userId,
            //        StartTime: this.StartTime,
            //        EndTime: this.EndTime,
            //    };
            //    this.listLoading = true;
            //    //NProgress.start();
            //    exportOrderInfo(para).then(res => {
            //        //var blob = new Blob([res], { type: res.type });
            //        var blob = new Blob([res.data], { type: 'application/vnd.ms-excel;Charset=utf-8' })
            //        // 针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            //        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //            window.navigator.msSaveOrOpenBlob(res, `订单信息_${moment().format('YYYYMMDDHHmmss')}.xls`)
            //        } else {
            //            var downloadElement = document.createElement('a')
            //            var href = window.URL.createObjectURL(blob)
            //            // 创建下载的链接
            //            downloadElement.href = href;
            //            downloadElement.download = `订单信息_${moment().format('YYYYMMDDHHmmss')}.xls`;
            //            // 下载后文件名
            //            document.body.appendChild(downloadElement);
            //            downloadElement.click(); // 点击下载
            //            document.body.removeChild(downloadElement); // 下载完成移除元素
            //            window.URL.revokeObjectURL(href); // 释放掉blob对象
            //        }
            //    });
            //    this.listLoading = false;
            //},


            getAllTimePeriods() {
                let para = {
                };
                this.listLoading = true;

                //NProgress.start();
                getAllTimePeriod(para).then((res) => {
                    this.allTimePeriods = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },


            getAllUserAddressList(UserId) {
                let para = {
                    UserId: UserId,
                };
                this.listLoading = true;

                //NProgress.start();
                getAllUserAddress(para).then((res) => {
                    this.allUserAddress = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            getAllGoodsNameList(UserId) {
                let para = {
                    UserId: UserId,
                };
                this.listLoading = true;

                //NProgress.start();
                getAllGoodsName(para).then((res) => {
                    this.allGoodsNames = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            getAllUserCouponList(UserId) {
                let para = {
                    UserId: UserId,
                };
                this.listLoading = true;

                //NProgress.start();
                getAllUserCoupon(para).then((res) => {
                    this.allUserCoupons = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },

        },
        mounted() {

            let nowTime = new Date();
            let year = nowTime.getFullYear();
            let month = nowTime.getMonth() + 1;
            let day = nowTime.getDate();
            let endTime = `${year}-${month}-${day}`;

            let befDate = new Date(nowTime.getTime() - 7 * 24 * 3600 * 1000);
            let byear = befDate.getFullYear();
            let bmonth = befDate.getMonth() + 1;
            let bday = befDate.getDate();

            let startTime = `${byear}-${bmonth}-${bday}`;

            this.StartTime = startTime;
            //this.StartTime = endTime;
            this.EndTime = endTime;

            //获得所有预约时段
            this.getAllTimePeriods();
            this.handleAllCouriers();
            this.getAllGoodsNameList();
            //this.getAllUserAddress();

            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.buttonList.forEach(item => {
                console.log(item.Func);
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleExport") {
                    this.isExport = true;
                } else if (item.Func == "handleCancelOrder") {
                    this.isCancelOrder = true;
                } else if (item.Func == "handleModifyCourier") {
                    this.isModifyCourier = true;
                }
            });

            this.$nextTick(function () {
                if (window.innerWidth > 700) {
                    //在页面渲染完成后
                    this.tableHeight = window.innerHeight - this.$refs.table.$el.getBoundingClientRect().top - 50
                    this.$refs.table.$el.getBoundingClientRect().top //表格距离浏览器的高度
                    var that = this
                    // 添加监听窗口大小变化事件
                    window.onresize = function () {
                        that.tableHeight = window.innerHeight - that.$refs.table.$el.getBoundingClientRect().top - 50
                    }
                };
                console.log("this.tableHeight=" + this.tableHeight);
                console.log("window.innerWidth=" + window.innerWidth);
            })
        },
    };
</script>

<style scoped>
    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }
</style>
<style>
    .vue-directive-image-previewer {
        z-index: 9999;
    }
</style>
